const tutorialContent = {
  tut1: {
    title: '',
    message: 'Xin Chào %{user}! Hãy bắt đầu trải nghiệm cùng FiinTrade.',
  },
  tut2: {
    title: 'MENU',
    message:
      'Menu bao gồm tất cả các chức năng của FiinTrade. Tùy chỉnh vùng làm việc bằng cách kéo và thả từng chức năng',
  },
  tut3: {
    title: 'VÙNG LÀM VIỆC',
    message:
      'Hãy chọn một vùng làm việc mẫu được cung cấp bởi FiinTrade hoặc khởi tạo vùng làm việc phù hợp mục đích sử dụng của bạn',
  },
  tut4: {
    title: 'CÀI ĐẶT',
    message: 'Cho phép tùy chỉnh và cập nhật thông tin cá nhân.',
  },
  tut5: {
    title: 'CHỨC NĂNG TẮT',
    message:
      'Chức năng tắt bao gồm 10 chức năng được sử dụng nhiều nhất. Thao tác nhanh để mang lại trải nghiệm tốt nhất khi giao dịch',
  },
  tut6: {
    title: 'TÌM KIẾM',
    message:
      'Cho phép tìm kiếm mã cổ phiếu và các chức năng liên quan tới mã cổ phiếu',
  },
  tut7: {
    title: 'NGÔN NGỮ',
    message:
      'Tùy chọn ngôn ngữ phù hợp với bạn. Hệ thống hiện tại bao gồm Tiếng Việt, Tiếng Anh và sẽ có thêm nhiều ngôn ngữ khác trong tương lai',
  },
  tut8: {
    title: 'GIAO DIỆN NGÀY/ĐÊM',
    message:
      'FiinTrade bao gồm 2 chế độ Ngày/ Đêm. Hãy chọn giao diện phù hợp để trải nghiệm tốt hơn.',
  },
};

export default {
  tutorialContent,
};
